import React from 'react';
import { Card, CardContent, Typography, Box, Button } from '@mui/material';
import { ChatBubble, Support, Feedback } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import './AdminSupportCard.css';

const AdminSupportCard = ({ onClick }) => {
  const { t } = useTranslation('homepage');
  return (
    <Card 
      className="admin-support-card"
      data-testid="admin-support-card"
      onClick={onClick}
      sx={{
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        '&:hover': {
          transform: 'translateY(-8px)',
          boxShadow: 6
        }
      }}
    >
      <CardContent sx={{ padding: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Support sx={{ fontSize: 40, mr: 2 }} />
          <Typography variant="h5" component="div" sx={{ fontWeight: 'bold' }}>
            {t('adminSupportCard.title')}
          </Typography>
        </Box>
        
        <Typography variant="body1" sx={{ mb: 2, opacity: 0.95 }}>
          {t('adminSupportCard.description')}
        </Typography>
        
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 2 }}>
          <Box sx={{ 
            display: 'inline-flex', 
            alignItems: 'center', 
            bgcolor: 'rgba(255,255,255,0.2)', 
            px: 1.5, 
            py: 0.5, 
            borderRadius: 2 
          }}>
            <ChatBubble sx={{ fontSize: 16, mr: 0.5 }} />
            <Typography variant="caption">{t('adminSupportCard.bugReport')}</Typography>
          </Box>
          <Box sx={{ 
            display: 'inline-flex', 
            alignItems: 'center', 
            bgcolor: 'rgba(255,255,255,0.2)', 
            px: 1.5, 
            py: 0.5, 
            borderRadius: 2 
          }}>
            <Feedback sx={{ fontSize: 16, mr: 0.5 }} />
            <Typography variant="caption">{t('adminSupportCard.featureSuggestion')}</Typography>
          </Box>
        </Box>
        
        <Button 
          variant="contained" 
          sx={{ 
            bgcolor: 'white', 
            color: '#667eea',
            fontWeight: 'bold',
            '&:hover': {
              bgcolor: 'rgba(255,255,255,0.9)'
            }
          }}
          fullWidth
        >
          {t('adminSupportCard.enter')}
        </Button>
      </CardContent>
    </Card>
  );
};

export default AdminSupportCard;
